import { Badge, BadgeProps, Box } from '@chakra-ui/react';
import { noop } from 'lodash';
import { convertPxToRems } from '~/utils-ts';

interface ChipProps extends BadgeProps {
  size?: 'S' | 'M' | 'L';
  rightIcon?: any;
  onRightIconClick?: () => void;
}

const PaddingMap = {
  S: `0.25rem 0.5rem`,
  M: `0.5rem 0.75rem`,
  L: `0.63rem 1rem`,
};

const FontSizeMap = {
  S: 'md',
  M: 'md',
  L: 'lg',
};
const LineHeightMap = {
  S: '1rem',
  M: '1rem',
  L: '1.125rem',
};

const IconSpacingMap = {
  S: '0.25rem', //4px
  M: '0.375rem',
  L: '0.5rem',
};

export const Chip: React.FC<ChipProps> = ({
  size = 'M',
  children,
  rightIcon,
  onRightIconClick = noop,
  ...props
}) => {
  return (
    <Badge
      padding={PaddingMap[size]}
      borderRadius={convertPxToRems(100)}
      fontSize={FontSizeMap[size]}
      fontWeight={500}
      lineHeight={LineHeightMap[size]}
      textTransform="none"
      color="primary.600"
      backgroundColor="primary.50"
      display="flex"
      alignItems="center"
      gap={IconSpacingMap[size]}
      _hover={{
        backgroundColor: 'primary.100',
      }}
      _active={{
        backgroundColor: 'primary.200',
      }}
      {...props}
    >
      <Box flex={1}>{children}</Box>
      {rightIcon ? (
        <Box
          as="button"
          onClick={onRightIconClick}
          color="primary.600"
          fill="primary.600"
          display="grid"
          alignItems="center"
          _hover={{
            backgroundColor: '',
          }}
        >
          {rightIcon}
        </Box>
      ) : null}
    </Badge>
  );
};
